// @flow
import moment from 'moment';
import { useContext } from 'react';

import { useRouter } from 'Client/router/useRouter';
import { getConfigWithNoThirdPartySupport } from 'Components/third-party/thirdParty.utils';
import ReactAppContext from 'Context/ReactAppContext';

export type ABTastyTransactionParams = {
  id: string,
  affiliation: string,
  revenue: number,
  currency: string,
};
export const sendTransaction = ({
  id,
  affiliation,
  revenue,
  currency,
}: ABTastyTransactionParams) => {
  const timeLimit = moment().add(5, 's');
  const waiter = setInterval(() => {
    if (window?.abtasty?.send) {
      window.abtasty.send('transaction', {
        tid: id, // Transaction ID
        ta: affiliation, // Transaction Affiliation
        tr: revenue, // Transaction Revenue
        tc: currency, // Transaction Currency
      });
      clearInterval(waiter);
    } else if (moment().isAfter(timeLimit)) {
      // clear after Maximum 5s, we assume that it should be there by then
      clearInterval(waiter);
    }
  }, 100);
};

type AbTastyHook = {
  abTastyScriptUrl: string,
  isAbTastyActive: boolean,
};
export const useAbTasty = (): AbTastyHook => {
  const appContext = useContext(ReactAppContext);
  const {
    location: { queryParams },
  } = useRouter<{}, GlobalQueryParams>();
  const tracking = getConfigWithNoThirdPartySupport({
    locale: appContext.locale,
    name: 'tracking',
    queryParams,
  });

  let abTastyId = tracking.abtasty.id;
  if (appContext.isCmta) {
    abTastyId = tracking.abtasty.cmta.id;
  } else if (appContext.isDirectCxo || appContext.isIndirectCxo) {
    abTastyId = tracking.abtasty.cxo.id;
  }

  const isAbTastyActive =
    tracking &&
    tracking.enabled &&
    tracking.abtasty &&
    tracking.abtasty.enabled &&
    tracking.abtasty.host &&
    !!abTastyId;

  const abTastyScriptUrl = isAbTastyActive
    ? `https://${tracking.abtasty.host}/${abTastyId}.js`
    : '';

  return { abTastyScriptUrl, isAbTastyActive };
};
